import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import FilterOrder from '~/@core/domain/filters/order/FilterOrder';
import GroupedOrder from '~/@core/domain/model/order/GroupedOrder';
import { OrderService } from '~/@core/infrastructure/api/services';
import IUseCase from '../../IUseCase';

export default class GetGroupedOrders
  implements IUseCase<FilterOrder, Promise<DefaultPaginated<GroupedOrder[]>>>
{
  execute(filter: FilterOrder): Promise<DefaultPaginated<GroupedOrder[]>> {
    return OrderService.fetchGroupedOrders(filter);
  }
}
